import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { BettingSelectionMappingDto } from "@/types/ApiResponses/BettingSelection";

export interface GetBettingSelectionMappingsParams {
  providerId?: number;
}

export const getBettingSelectionMappings = async (
  selectionId: number,
  props: QueryProps<GetBettingSelectionMappingsParams>
): Promise<BettingSelectionMappingDto[]> => {
  const res = await api.client.get(`/betting-selections-new/${selectionId}/mappings`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
